import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { services } from '../data/mock';
import {
  Construction,
  Paintbrush,
  Sun,
  Gem,
  Settings,
  Lightbulb,
  Search,
  Droplets,
  RefreshCw,
  Waves
} from 'lucide-react';

const iconMap = {
  Construction,
  Paintbrush,
  Sun,
  Gem,
  Settings,
  Lightbulb,
  Search,
  Droplets,
  RefreshCw,
  Waves
};

const Services = () => {
  return (
    <section id="services" className="py-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-cyan-100 text-cyan-700 text-sm font-semibold mb-4">
            Our Services
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-800 mb-6">
            Complete Pool{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-500 to-blue-600">
              Solutions
            </span>
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed">
            From construction to maintenance, we offer a full range of professional pool services
            to keep your swimming experience perfect year-round.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="group relative bg-white border-slate-200/80 hover:border-cyan-300 hover:shadow-xl hover:shadow-cyan-500/10 transition-all duration-300 cursor-pointer overflow-hidden"
                style={{ animationDelay: `${index * 50}ms` }}
              >
                {/* Hover gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/0 to-blue-600/0 group-hover:from-cyan-500/5 group-hover:to-blue-600/5 transition-all duration-300" />
                
                <CardHeader className="relative pb-2">
                  <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-cyan-50 to-blue-50 flex items-center justify-center mb-4 group-hover:from-cyan-100 group-hover:to-blue-100 transition-colors duration-300">
                    {IconComponent && (
                      <IconComponent className="w-7 h-7 text-cyan-600 group-hover:text-cyan-700 transition-colors" />
                    )}
                  </div>
                  <CardTitle className="text-lg font-semibold text-slate-800 group-hover:text-cyan-700 transition-colors">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="relative">
                  <p className="text-sm text-slate-500 leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>

                {/* Bottom accent line */}
                <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-cyan-500 to-blue-600 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300" />
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
